import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FieldsOptions } from '@recipes/recipes-translation/recipes-translation-input-fields/recipes-translation-input-fields.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-recipes-translation-field',
  imports: [CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './recipes-translation-field.component.html',
  styleUrls: ['./recipes-translation-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecipesTranslationFieldComponent {
  @Input() fieldOptions: {
    control: FormControl<string>;
    requiredTranslationKey?: string;
  } & Pick<FieldsOptions, 'size' | 'label' | 'placeholder'>;
}
